import React from "react";
import Icon from "../icon/Icon";
import { Pagination, PaginationLink, PaginationItem } from "reactstrap";

const PaginationComponent = ({ itemPerPage, totalItems, paginate, currentPage }) => {
  const totalPages = Math.ceil(totalItems / itemPerPage);
  const pageNumbers = [];

  // Show max 5 pages around current
  let startPage = Math.max(1, currentPage - 2);
  let endPage = Math.min(totalPages, currentPage + 2);

  if (startPage > 1) pageNumbers.push(1, '...');
  for (let i = startPage; i <= endPage; i++) pageNumbers.push(i);
  if (endPage < totalPages) pageNumbers.push('...', totalPages);

  const nextPage = () => currentPage < totalPages && paginate(currentPage + 1);
  const prevPage = () => currentPage > 1 && paginate(currentPage - 1);

  return (
    <Pagination aria-label="Page navigation example">
      <PaginationItem disabled={currentPage === 1}>
        <PaginationLink onClick={(e) => { e.preventDefault(); prevPage(); }} href="#prev">
          Prev
        </PaginationLink>
      </PaginationItem>

      {pageNumbers.map((item, idx) => (
        <PaginationItem key={idx} active={currentPage === item}>
          {item === "..." ? (
            <PaginationLink>{item}</PaginationLink>
          ) : (
            <PaginationLink onClick={(e) => { e.preventDefault(); paginate(item); }} href="#pageitem">
              {item}
            </PaginationLink>
          )}
        </PaginationItem>
      ))}

      <PaginationItem disabled={currentPage === totalPages}>
        <PaginationLink onClick={(e) => { e.preventDefault(); nextPage(); }} href="#next">
          Next
        </PaginationLink>
      </PaginationItem>
    </Pagination>
  );
};
export default PaginationComponent;
